var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	7556: {
		fallback: () => (Promise.all([__webpack_require__.e(9427), __webpack_require__.e(7399), __webpack_require__.e(2260), __webpack_require__.e(2076), __webpack_require__.e(9460)]).then(() => (() => (__webpack_require__(9460))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.20",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	9427: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(1340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	7399: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(3620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	9586: {
		fallback: () => (Promise.all([__webpack_require__.e(9427), __webpack_require__.e(1352)]).then(() => (() => (__webpack_require__(1352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.20",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	4427: {
		fallback: () => (Promise.all([__webpack_require__.e(2229), __webpack_require__.e(6545), __webpack_require__.e(4155)]).then(() => (() => (__webpack_require__(4155))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "4.0.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ford-fusion/angular",

	},
	8910: {
		fallback: () => (__webpack_require__.e(4285).then(() => (() => (__webpack_require__(4285))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-toastr",

	},
	6545: {
		fallback: () => (Promise.all([__webpack_require__.e(9427), __webpack_require__.e(7399), __webpack_require__.e(9586), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(4456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.24",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	1029: {
		fallback: () => (Promise.all([__webpack_require__.e(4967), __webpack_require__.e(2992), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.20",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	2270: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9586), __webpack_require__.e(1029), __webpack_require__.e(7415)]).then(() => (() => (__webpack_require__(7415))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.20",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	2992: {
		fallback: () => (Promise.all([__webpack_require__.e(9427), __webpack_require__.e(7399), __webpack_require__.e(6613)]).then(() => (() => (__webpack_require__(6613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.20",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	6228: {
		fallback: () => (__webpack_require__.e(597).then(() => (() => (__webpack_require__(597))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-translate/core",

	},
	5163: {
		fallback: () => (__webpack_require__.e(9676).then(() => (() => (__webpack_require__(9676))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.30.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-browser",

	},
	5685: {
		fallback: () => (Promise.all([__webpack_require__.e(4967), __webpack_require__.e(9367), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(3835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.24",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	8879: {
		fallback: () => (__webpack_require__.e(8653).then(() => (() => (__webpack_require__(8653))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-angular",

	},
	2981: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.24",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	6333: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(6699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.24",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	9367: {
		fallback: () => (__webpack_require__.e(1887).then(() => (() => (__webpack_require__(1887))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.24",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	2229: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(2260), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(9074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.24",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	2289: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(5749)]).then(() => (() => (__webpack_require__(7172))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.24",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",

	},
	8667: {
		fallback: () => (Promise.all([__webpack_require__.e(6545), __webpack_require__.e(6769)]).then(() => (() => (__webpack_require__(6769))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.1.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-mask",

	},
	752: {
		fallback: () => (__webpack_require__.e(2972).then(() => (() => (__webpack_require__(2972))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vehicle-checklist-ui/Routes",

	},
	6957: {
		fallback: () => (__webpack_require__.e(6776).then(() => (() => (__webpack_require__(6776))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "angular2-signaturepad",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"752": [
		752
	],
	"1029": [
		1029
	],
	"1843": [
		6228
	],
	"2229": [
		2229
	],
	"2260": [
		2981,
		6333
	],
	"2270": [
		2270
	],
	"2972": [
		8667
	],
	"2992": [
		2992
	],
	"4285": [
		2289
	],
	"4427": [
		4427
	],
	"5163": [
		5163
	],
	"5467": [
		6957
	],
	"6075": [
		5685,
		8879
	],
	"6545": [
		6545
	],
	"7399": [
		7399
	],
	"7556": [
		7556
	],
	"8910": [
		8910
	],
	"9367": [
		9367
	],
	"9427": [
		9427
	],
	"9586": [
		9586
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}